import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./cliente-listar/cliente-listar.module').then(m => m.ClienteListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./cliente-editar/cliente-editar.module').then(m => m.ClienteEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./cliente-inserir/cliente-inserir.module').then(m => m.ClienteInserirModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./cliente-detalhar/cliente-detalhar.module').then(m => m.ClienteDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class ClienteAppRoutingModule { }